define(
    'utils/rivets-binders',[
        'jquery',
        'rivets',
        'utils/string-interpolate'
    ],

    function ($, rivets, s) {
        rivets.binders['style-background-image'] = function(el, value){
            if (value) {
                if (value.substr(-4) === '.svg') {
                    // Replace with png if no SVG support
                    if ($('html').hasClass('no-svg')) {
                        value = value.substr(0, value.length - 4) + '.png';
                    }
                }

                el.style.setProperty('background-image', s('url(%s)', [value]));    
            }
        };
    }
);
